import { Component, computed, inject, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrnCommandImports } from '@spartan-ng/brain/command';
import { BrnPopoverImports } from '@spartan-ng/brain/popover';
import { BrnSelectImports } from '@spartan-ng/brain/select';
import { HlmCommandImports } from '@spartan-ng/helm/command';
import { HlmFieldImports } from '@spartan-ng/helm/field';
import { HlmInputImports } from '@spartan-ng/helm/input';
import { HlmLabelImports } from '@spartan-ng/helm/label';
import { HlmPopoverImports } from '@spartan-ng/helm/popover';
import { HlmSelectImports } from '@spartan-ng/helm/select';

import { CaractéristiqueStore } from '../../../../référentiel-métier/référentiel-métier-périmètre/perimetre-caracteristiques/store/caractéristique.store';
import { TrierParPipe } from '../../../../shared/pipes/trier-par.pipe';
import { DetailMetierFormGroup } from '../jalon-detail-form-groups.types';
import { JalonDetailFormService } from '../jalon-detail-form.service';

@Component({
  selector: 'app-detail-metier',
  imports: [
    ReactiveFormsModule,
    TrierParPipe,
    HlmLabelImports,
    HlmPopoverImports,
    HlmCommandImports,
    HlmSelectImports,
    HlmInputImports,
    BrnCommandImports,
    BrnSelectImports,
    BrnPopoverImports,
    HlmFieldImports,
  ],
  templateUrl: './detail-metier.component.html',
})
export class DetailMetierComponent {
  readonly form = input.required<DetailMetierFormGroup>();
  readonly #caractéristiqueStore = inject(CaractéristiqueStore);
  readonly jalonDetailFormService = inject(JalonDetailFormService);

  readonly secteur = computed(() => this.#caractéristiqueStore.caracteristiques().find((x) => x.estSecteur));

  readonly emploisPossibles = computed(() => this.jalonDetailFormService.emploisPossibles);

  readonly competencesTransverses = computed(() => this.jalonDetailFormService.competencesTransverses);

  compareWithId = (o1: { id: string }, o2: { id: string }) => o1.id === o2.id;
}
